import { Navigate, useLocation } from 'react-router-dom';
import type { ReactNode } from 'react';
import { useAuth } from './AuthProvider';

/** Gates a route behind a Supabase session, remembering where to return to. */
export function RequireAuth({ children }: { children: ReactNode }) {
  const { session, loading } = useAuth();
  const location = useLocation();

  if (loading) return <p className="muted">Đang kiểm tra phiên đăng nhập…</p>;
  if (!session) {
    return <Navigate to="/dang-nhap" replace state={{ from: location.pathname }} />;
  }
  return <>{children}</>;
}
